import { render, staticRenderFns } from "./verifyKidAccount.vue?vue&type=template&id=a8b9ce46&scoped=true&"
import script from "./verifyKidAccount.vue?vue&type=script&lang=js&"
export * from "./verifyKidAccount.vue?vue&type=script&lang=js&"
import style0 from "./verifyKidAccount.vue?vue&type=style&index=0&id=a8b9ce46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b9ce46",
  null
  
)

export default component.exports